// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: CaPyUeyrEOr7
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSample.module.css"; // plasmic-import: CaPyUeyrEOr7/css
import VisaLogoIcon from "./icons/PlasmicIcon__VisaLogo"; // plasmic-import: oYd1Jp6qlXiW/icon
import AmexIcon from "./icons/PlasmicIcon__Amex"; // plasmic-import: cwGCMDhEp44s/icon
import mastercardMspf6Ol1QQ6B from "./images/mastercard.svg"; // plasmic-import: Mspf6OL1qQ6b/picture
import discover2PSsVVmYxwPB from "./images/discover2.svg"; // plasmic-import: PSsVVmYxwP_B/picture
import image17TPdaWxpQrtp from "./images/image17.png"; // plasmic-import: tPdaWXP_QRTP/picture

createPlasmicElementProxy;

export const PlasmicSample__VariantProps = new Array();

export const PlasmicSample__ArgProps = new Array();

const $$ = {};

function PlasmicSample__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "expDate.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "cardNumber.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "cvc.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"center"}
      data-plasmic-override={overrides.center}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.center
      )}
    >
      <div
        data-plasmic-name={"figmaPaste"}
        data-plasmic-override={overrides.figmaPaste}
        className={classNames(projectcss.all, sty.figmaPaste)}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__whHkW
          )}
        >
          {"Card Number"}
        </div>
        <div
          data-plasmic-name={"cardNumber2"}
          data-plasmic-override={overrides.cardNumber2}
          className={classNames(projectcss.all, sty.cardNumber2)}
        >
          <div
            data-plasmic-name={"_1234123412341234"}
            data-plasmic-override={overrides._1234123412341234}
            className={classNames(projectcss.all, sty._1234123412341234)}
          >
            <input
              data-plasmic-name={"cardNumber"}
              data-plasmic-override={overrides.cardNumber}
              aria-label={""}
              className={classNames(
                projectcss.all,
                projectcss.input,
                sty.cardNumber
              )}
              disabled={false}
              id={"cardNumber"}
              onChange={async (...eventArgs) => {
                (e => {
                  generateStateOnChangeProp($state, ["cardNumber", "value"])(
                    e.target.value
                  );
                }).apply(null, eventArgs);
              }}
              placeholder={"1234 1234 1234 1234"}
              ref={ref => {
                $refs["cardNumber"] = ref;
              }}
              size={1}
              title={""}
              type={"text"}
              value={
                generateStateValueProp($state, ["cardNumber", "value"]) ?? ""
              }
            />
          </div>
          <div
            data-plasmic-name={"paymentMethodVisa"}
            data-plasmic-override={overrides.paymentMethodVisa}
            className={classNames(projectcss.all, sty.paymentMethodVisa)}
          >
            <div
              data-plasmic-name={"base"}
              data-plasmic-override={overrides.base}
              className={classNames(projectcss.all, sty.base)}
            >
              <VisaLogoIcon
                className={classNames(projectcss.all, sty.svg__x0UdD)}
                role={"img"}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"icon"}
            data-plasmic-override={overrides.icon}
            className={classNames(projectcss.all, sty.icon)}
          />

          <div
            data-plasmic-name={"paymentMethodMastercard"}
            data-plasmic-override={overrides.paymentMethodMastercard}
            className={classNames(projectcss.all, sty.paymentMethodMastercard)}
          >
            <div
              data-plasmic-name={"base2"}
              data-plasmic-override={overrides.base2}
              className={classNames(projectcss.all, sty.base2)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__eLpUf)}
                displayHeight={"11.3px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobile")
                    ? "17.4px"
                    : hasVariant(globalVariants, "screen", "large")
                    ? "17.4px"
                    : "17.33px"
                }
                loading={"lazy"}
                src={{
                  src: mastercardMspf6Ol1QQ6B,
                  fullWidth: 19.928,
                  fullHeight: 12.228,
                  aspectRatio: 1.538462
                }}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"icon2"}
            data-plasmic-override={overrides.icon2}
            className={classNames(projectcss.all, sty.icon2)}
          />

          <div
            data-plasmic-name={"paymentMethodAmex"}
            data-plasmic-override={overrides.paymentMethodAmex}
            className={classNames(projectcss.all, sty.paymentMethodAmex)}
          >
            <div
              data-plasmic-name={"base3"}
              data-plasmic-override={overrides.base3}
              className={classNames(projectcss.all, sty.base3)}
            >
              <AmexIcon
                className={classNames(projectcss.all, sty.svg__alKme)}
                role={"img"}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"icon3"}
            data-plasmic-override={overrides.icon3}
            className={classNames(projectcss.all, sty.icon3)}
          />

          <div
            data-plasmic-name={"paymentMethodDiscover"}
            data-plasmic-override={overrides.paymentMethodDiscover}
            className={classNames(projectcss.all, sty.paymentMethodDiscover)}
          >
            <div
              data-plasmic-name={"base4"}
              data-plasmic-override={overrides.base4}
              className={classNames(projectcss.all, sty.base4)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__z3Se1)}
                displayHeight={"11.3px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobile")
                    ? "23.4px"
                    : "23.6px"
                }
                loading={"lazy"}
                src={{
                  src: discover2PSsVVmYxwPB,
                  fullWidth: 26.571,
                  fullHeight: 12.4,
                  aspectRatio: 2.076923
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__qAtzM
          )}
        >
          {"Card Expiration"}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__dGa)}>
          <input
            data-plasmic-name={"expDate"}
            data-plasmic-override={overrides.expDate}
            aria-label={""}
            className={classNames(
              projectcss.all,
              projectcss.input,
              sty.expDate
            )}
            id={"expDate"}
            onChange={async (...eventArgs) => {
              (e => {
                generateStateOnChangeProp($state, ["expDate", "value"])(
                  e.target.value
                );
              }).apply(null, eventArgs);
            }}
            placeholder={"MM / YY"}
            ref={ref => {
              $refs["expDate"] = ref;
            }}
            size={1}
            type={"text"}
            value={generateStateValueProp($state, ["expDate", "value"]) ?? ""}
          />
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__vNpZ
          )}
        >
          {"Card CVC"}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__uLxpx)}>
          <input
            data-plasmic-name={"cvc"}
            data-plasmic-override={overrides.cvc}
            aria-label={""}
            className={classNames(projectcss.all, projectcss.input, sty.cvc)}
            id={"cvc"}
            onChange={async (...eventArgs) => {
              (e => {
                generateStateOnChangeProp($state, ["cvc", "value"])(
                  e.target.value
                );
              }).apply(null, eventArgs);
            }}
            placeholder={"CVC"}
            ref={ref => {
              $refs["cvc"] = ref;
            }}
            size={1}
            type={"text"}
            value={generateStateValueProp($state, ["cvc", "value"]) ?? ""}
          />

          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__q0Rk)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"7.5%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: image17TPdaWxpQrtp,
              fullWidth: 512,
              fullHeight: 512,
              aspectRatio: undefined
            }}
          />
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__uibyA
          )}
        >
          {"Zip Code"}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___1Eud8)}>
          <input
            data-plasmic-name={"zip"}
            data-plasmic-override={overrides.zip}
            aria-label={""}
            className={classNames(projectcss.all, projectcss.input, sty.zip)}
            id={"zip"}
            onChange={async (...eventArgs) => {
              (e => {
                generateStateOnChangeProp($state, ["zip", "value"])(
                  e.target.value
                );
              }).apply(null, eventArgs);
            }}
            placeholder={"00000"}
            ref={ref => {
              $refs["zip"] = ref;
            }}
            size={1}
            type={"text"}
            value={generateStateValueProp($state, ["zip", "value"]) ?? ""}
          />
        </div>
        <div
          data-plasmic-name={"errorText"}
          data-plasmic-override={overrides.errorText}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.errorText
          )}
        >
          {"Please enter all of the fields"}
        </div>
        <div
          data-plasmic-name={"payButton"}
          data-plasmic-override={overrides.payButton}
          className={classNames(projectcss.all, sty.payButton)}
          id={"credit-card-submit"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__iqM4S
            )}
          >
            {"Pay"}
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  center: [
    "center",
    "figmaPaste",
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4",
    "expDate",
    "cvc",
    "zip",
    "errorText",
    "payButton"
  ],

  figmaPaste: [
    "figmaPaste",
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4",
    "expDate",
    "cvc",
    "zip",
    "errorText",
    "payButton"
  ],

  cardNumber2: [
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4"
  ],

  _1234123412341234: ["_1234123412341234", "cardNumber"],
  cardNumber: ["cardNumber"],
  paymentMethodVisa: ["paymentMethodVisa", "base"],
  base: ["base"],
  icon: ["icon"],
  paymentMethodMastercard: ["paymentMethodMastercard", "base2"],
  base2: ["base2"],
  icon2: ["icon2"],
  paymentMethodAmex: ["paymentMethodAmex", "base3"],
  base3: ["base3"],
  icon3: ["icon3"],
  paymentMethodDiscover: ["paymentMethodDiscover", "base4"],
  base4: ["base4"],
  expDate: ["expDate"],
  cvc: ["cvc"],
  zip: ["zip"],
  errorText: ["errorText"],
  payButton: ["payButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSample__ArgProps,
          internalVariantPropNames: PlasmicSample__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSample__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "center") {
    func.displayName = "PlasmicSample";
  } else {
    func.displayName = `PlasmicSample.${nodeName}`;
  }
  return func;
}

export const PlasmicSample = Object.assign(
  // Top-level PlasmicSample renders the root element
  makeNodeComponent("center"),
  {
    // Helper components rendering sub-elements
    figmaPaste: makeNodeComponent("figmaPaste"),
    cardNumber2: makeNodeComponent("cardNumber2"),
    _1234123412341234: makeNodeComponent("_1234123412341234"),
    cardNumber: makeNodeComponent("cardNumber"),
    paymentMethodVisa: makeNodeComponent("paymentMethodVisa"),
    base: makeNodeComponent("base"),
    icon: makeNodeComponent("icon"),
    paymentMethodMastercard: makeNodeComponent("paymentMethodMastercard"),
    base2: makeNodeComponent("base2"),
    icon2: makeNodeComponent("icon2"),
    paymentMethodAmex: makeNodeComponent("paymentMethodAmex"),
    base3: makeNodeComponent("base3"),
    icon3: makeNodeComponent("icon3"),
    paymentMethodDiscover: makeNodeComponent("paymentMethodDiscover"),
    base4: makeNodeComponent("base4"),
    expDate: makeNodeComponent("expDate"),
    cvc: makeNodeComponent("cvc"),
    zip: makeNodeComponent("zip"),
    errorText: makeNodeComponent("errorText"),
    payButton: makeNodeComponent("payButton"),
    // Metadata about props expected for PlasmicSample
    internalVariantProps: PlasmicSample__VariantProps,
    internalArgProps: PlasmicSample__ArgProps
  }
);

export default PlasmicSample;
/* prettier-ignore-end */
